import * as React from "react";
import FilterBuilder from "devextreme-react/filter-builder";
import { dxFilterBuilderField } from "devextreme/ui/filter_builder";

export interface Field extends dxFilterBuilderField {

}

export interface QueryProviderProps {
    fields: Field[]
    children: (renderOpts: { filter: React.ReactNode }) => React.ReactNode
}

export interface Query {
    query: string[]
}

export interface QueryProviderState {
    query: Query
}

const context = React.createContext<Query>({ query: [] })
export const QueryContextProvider = context.Provider
export const QueryContextConsumer = context.Consumer

export const QueryContextType = context

export class QueryProvider extends React.Component<QueryProviderProps, QueryProviderState> {
    constructor(p: QueryProviderProps) {
        super(p);
        this.state = {
            query: {
                query: new Array()
            }
        }
    }

    renderFilter() {
        const { fields } = this.props
        return <FilterBuilder fields={fields} value={this.state.query.query} onValueChanged={(e) => {
            this.setState({ query: { query: e.value } })
        }}>
        </FilterBuilder>
    }

    render() {
        return <QueryContextProvider value={this.state.query}>
            {this.props.children({ filter: this.renderFilter() })}
        </QueryContextProvider>
    }
}


// WEBPACK FOOTER //
// ./src/components/context/query.tsx